"use client";

import React, { useState, useEffect } from "react";
import HeaderSection from "../../layout/HeaderSection";
import ProjectsGrid from "./components/ProjectsGrid";
import Footer from "../../layout/Footer";
import { projects } from "../../../api/collections/projectsApi";
import { Project } from "@/types/projectType";

/**
 * Project Page Component
 * Main component for the projects page displaying project portfolio
 */
const ProjectPage: React.FC = () => {
  const [projectsData, setProjectsData] = useState<Project[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await projects.getAll();

        if (response.success && response.data) {
          setProjectsData(response.data);
        } else {
          setError(response.error?.message || "Không thể tải dữ liệu dự án");
        }
      } catch (err) {
        setError("Đã xảy ra lỗi khi tải dữ liệu dự án");
        console.error("Error fetching projects:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  // Handle project click - for future implementation (e.g., modal or navigation)
  const handleProjectClick = (project: Project) => {
    console.log("Project clicked:", project);
    // TODO: Implement project detail view
    // This could open a modal, navigate to a detail page, etc.
  };

  return (
    <div className="min-h-screen">
      {/* Header Section */}
      <HeaderSection
        title="Dự án"
        subtitle="Khám phá những dự án tiêu biểu của chúng tôi"
        backgroundImage="/header_90ad.png"
        ariaLabel="Projects page header"
        overlayOpacity="medium"
      />

      {/* Projects Grid Section */}
      <ProjectsGrid
        projects={projectsData}
        loading={loading}
        error={error}
        onProjectClick={handleProjectClick}
      />

      {/* Footer Section */}
      <Footer />
    </div>
  );
};

export default ProjectPage;
